import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectEntrancesInView,
  selectGridData,
  selectTableEntrances,
  selectEntranceName,
} from '../../../../lib/storeSelectors';
import {
  setActiveEntranceName,
  setFlatsTablePage,
} from '../../../../../../store/actions/housingStockActions';
import { flatsViews } from '../../../../../../constants/flatsViews';
import EntrancesTabs from '../../../../../../components/ui/EntrancesTabs/EntrancesTabs';

const emptyArr = [];

const GridEntranceTabs = ({ className, onChange }) => {
  const inView = useSelector(selectEntrancesInView);
  const gridData = useSelector(selectGridData);

  return (
    <EntrancesTabs
      className={className}
      items={gridData.length > 1 ? gridData : emptyArr}
      tabsValue={inView}
      onChange={onChange}
    />
  );
};

const TableEntranceTabs = ({ className, onChange }) => {
  const entrances = useSelector(selectTableEntrances);
  const entranceName = useSelector(selectEntranceName);

  return (
    <EntrancesTabs
      className={className}
      items={entrances || emptyArr}
      tabsValue={entranceName}
      onChange={onChange}
    />
  );
};

const tabs = {
  [flatsViews.table]: (props) => <TableEntranceTabs {...props} />,
  [flatsViews.grid]: (props) => <GridEntranceTabs {...props} />,
};

const EntranceTabs = ({ view, className }) => {
  const dispatch = useDispatch();

  const handleChange = (_evt, newValue) => {
    dispatch(setActiveEntranceName(newValue));
    dispatch(setFlatsTablePage(0));
  };

  return tabs[view]({ className, onChange: handleChange });
};

export default EntranceTabs;
